import { classnames, onReturnKey } from "lib/helpers";
import { TreeContext } from "pages/Editor";
import { useContext, useEffect, useRef, useState } from "react";

function Page({ page, active, setActive, rename }) {
  const ref = useRef();
  const [editing, setEditing] = useState(false);
  function onKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      rename(e.target.innerHTML);
      setEditing(false);
    }
  }
  useEffect(() => {
    ref.current.innerHTML = page.name;
  }, [page]);
  return (
    <div
      ref={ref}
      className={classnames("pg-i", { a: active })}
      onDoubleClick={() => setEditing(true)}
      onKeyDown={onKeyDown}
      contentEditable={editing}
      onClick={setActive}
    />
  );
}

export default function Pages() {
  const { page, pages, setPage, addPage, updateTree } = useContext(TreeContext);
  const [create, setCreate] = useState(false);
  const input = useRef();
  useEffect(() => {
    if (create) input.current.focus();
  }, [create]);
  function onKeyDown(e) {
    onReturnKey(() => {
      addPage(e.target.value);
      setCreate(false);
    })(e);
  }
  function renamePage(key, name) {
    updateTree("pages." + key + ".name", name);
  }
  return (
    <div className="pg">
      <div className="pg-c">
        {Object.entries(pages.pages || {}).map(([key, p]) => {
          return (
            <Page
              key={key}
              page={p}
              active={page === key}
              setActive={() => setPage(key)}
              rename={(name) => renamePage(key, name)}
            />
          );
        })}
        {create && <input type="text" ref={input} {...{ onKeyDown }} />}
      </div>
      <div className="pg-f">
        <button onClick={() => setCreate(true)}>
          <i className="fa fa-plus" />
        </button>
      </div>
    </div>
  );
}
